import { toast } from "sonner";

const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again.";

const normaliseMessage = (value) => {
  if (typeof value === "string") return value.trim();
  if (value == null) return "";
  return String(value).trim();
};

const getApiErrorMessages = (error, fallbackMessage = DEFAULT_ERROR_MESSAGE) => {
  const responseData = error?.response?.data;
  const errors = responseData?.errors;
  const messages = [];

  if (Array.isArray(errors)) {
    errors.forEach((item) => {
      const message = normaliseMessage(
        typeof item === "string" ? item : item?.message ?? item?.errorMessage
      );
      if (message) messages.push(message);
    });
  } else if (errors && typeof errors === "object") {
    Object.values(errors).flat().forEach((item) => {
      const message = normaliseMessage(
        typeof item === "string" ? item : item?.message ?? item?.errorMessage
      );
      if (message) messages.push(message);
    });
  }

  if (messages.length === 0) {
    const responseMessage = normaliseMessage(responseData?.message);
    const errorMessage = normaliseMessage(error?.message);
    messages.push(responseMessage || fallbackMessage);
  }

  return [...new Set(messages)];
};

const ToastHelper = {
  success(message, options) {
    return toast.success(message, options);
  },

  info(message, options) {
    return toast.info(message, options);
  },

  warning(message, options) {
    return toast.warning(message, options);
  },

  error(messageOrError, options) {
    if (messageOrError?.response) {
      return this.apiError(messageOrError);
    }
    return toast.error(messageOrError || DEFAULT_ERROR_MESSAGE, options);
  },

  apiError(error, fallbackMessage = DEFAULT_ERROR_MESSAGE) {
    const messages = getApiErrorMessages(error, fallbackMessage);
    toast.error(messages.join("\n"), {
      className: "whitespace-pre-line",
    });
    return messages;
  },

  apiSuccess(response, fallbackMessage = "Saved successfully.") {
    const message = response?.data?.message || response?.message || fallbackMessage;
    return toast.success(message);
  },

  dismiss(toastId) {
    return toast.dismiss(toastId);
  },

  promise(promise, messages) {
    return toast.promise(promise, messages);
  },
};

export { getApiErrorMessages };
export default ToastHelper;
